<template>
  <v-row>
    <v-col cols="9">
      <v-card>
        <v-card-text>
          <v-form ref="userForm" lazy-validation v-model="valid">
            <v-col lg12 justify-center>
              <v-col lg12 sm12>
                <v-img
                  class="text-lg-center ma-3"
                  :src="avatar ? avatar.url : require('@/assets/images/img_404.png')"
                  cover
                  max-width="200"
                  acpect-ration="1"
                >
                </v-img>
                <v-text-field
                  label="Выберите изображение"
                  @click="pickFile"
                  v-model="imageName"
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="imageInput"
                  accept="image/*"
                  name="avatar"
                  @change="onFilePicked"
                />
              </v-col>
              <v-col lg12 sm12>
                <v-col justify-center column class="ma-3">
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.name"
                      label="Полное имя"
                      required
                      name="name"
                      :rules="notEmptyRules"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.email"
                      label="email"
                      required
                      name="email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="user.phone_number"
                      label="Номер телефона"
                      required
                      name="phone_number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <SiteSelect
                      :site="user.region"
                      field-name="region"
                      :global="false"
                      @site-selected="siteSelected"
                    >
                    </SiteSelect>
                  </v-col>
                  <v-col>
                    <v-combobox
                      v-model="roles"
                      :items="roleList"
                      multiple
                      small-chips
                      item-value="key"
                      item-text="name"
                      label="Роль"
                      :rules="notEmptyRules"
                    ></v-combobox>
                    <!--                    <input class="hidden" type="text" name="roles" v-model="user.roles.join(',')">-->
                  </v-col>
                  <v-col>
                    <v-row row wrap>
                      <v-col>
                        <div v-if="isEdit">
                          <h4 class="caption font-weight-light">Имя пользователя</h4>
                          <h3 class="subheading .font-weight-bold">{{ user.username }}</h3>
                        </div>
                      </v-col>
                      <v-col>
                        <v-switch
                          color="green"
                          v-model="user.is_active"
                          label="Активный"
                        ></v-switch>
                        <input type="text" name="is_active" :value="user.is_active" hidden />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-col>
              </v-col>
            </v-col>
            <v-row row>
              <v-col>
                <v-btn color="light-green " dark @click="validateAndSubmit">Сохранить</v-btn>
              </v-col>
              <v-col>
                <v-btn
                  class="text-lg-center"
                  style="margin: 0 auto"
                  tag="div"
                  v-if="isEdit"
                  color="orange accent-4"
                  dark
                  @click="resetPassword"
                >
                  Сбросить пароль
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>

      <v-dialog v-model="modal.active" max-width="500px" persistent>
        <v-card>
          <v-card-text class="text-lg-center">
            <div v-if="modal.messageUsername" class="text-lg-center">
              <h3 class="subheading">Имя пользователя</h3>
              <div class="display-1 pa-2">{{ modal.messageUsername }}</div>
            </div>
            <div v-if="modal.messagePassword" class="text-lg-center">
              <h3 class="subheading">Пароль</h3>
              <div class="display-1 pa-2">{{ modal.messagePassword }}</div>
            </div>
            <div v-if="modal.message" class="text-lg-center">
              {{ modal.message }}
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="text-lg-center">
            <v-col cols="12" align-self-center>
              <v-btn color="primary" flat @click="modal.active = false">Закрыть</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import apiMixin from '@/mixins/api'
import userMixin from '@/mixins/user'
import copyText from '@/utils/copy'
import SiteSelect from '@/components/SiteSelect'

const defaultModal = {
  active: false,
  message: '',
  messageUsername: '',
  messagePassword: '',
}

export default {
  name: 'UserCreate',
  components: { SiteSelect },
  mixins: [apiMixin, userMixin],
  data() {
    return {
      notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
      breadcrumbs: [
        {
          href: this.$router.resolve({ name: 'users' }).href,
          text: 'Пользователи',
        },
      ],
      valid: false,
      role: '',
      region: '',
      modal: { ...defaultModal },
      alertType: 'error',
      imageName: '',
      avatar: null,
      user: { roles: [], region: '' },
      inited: false,
      sourceUser: {},
    }
  },
  computed: {
    roles: {
      get() {
        const keys = []
        for (let x of this.user.roles) {
          const key = {
            key: x,
            name: this.roleString(x),
          }
          keys.push(key)
        }
        return keys
      },
      set(val) {
        const arr = []
        for (let v of val) {
          arr.push(v.key)
        }
        this.user.roles = arr
      },
    },
    changed() {
      for (let k in this.sourceUser) {
        if (this.sourceUser[k] !== this.user[k]) {
          return true
        }
      }
      return false
    },
    isEdit() {
      return !!this.$route.params.id
    },
  },
  created() {
    this.needUpdate = false
  },
  async mounted() {
    this.getSites()
    this.getRoleList()
    if (this.isEdit) {
      try {
        const data = (await this.getUser(this.$route.params.id)).data
        this.user = { ...data }
        this.avatar = data.avatar
        this.sourceUser = { ...data }
      } catch (e) {
        this.$log.error(e)
        this.showSnackbar(e, 'error')
      }
    }
  },
  methods: {
    copyPassword(pass) {
      copyText(pass)
    },
    validateAndSubmit() {
      if (this.$refs.userForm.validate()) {
        this.createOrUpdateUser()
      } else {
        this.message = 'Заполника все поля'
        this.alertType = 'error'
        this.modal.active = true
      }
    },
    createOrUpdateUser() {
      this.modal = { ...defaultModal }
      const formData = new FormData(this.$refs.userForm.$el)
      this.user.roles.forEach((x) => {
        formData.append('roles[]', x)
      })
      this.axios({
        url: this.isEdit ? `/v1/users/${this.$route.params.id}` : '/v1/users',
        method: this.isEdit ? 'patch' : 'post',
        data: formData,
      })
        .then((resp) => {
          this.alertType = 'success'
          this.modal.messagePassword = resp.data.password
          this.modal.messageUsername = resp.data.username
          this.message = this.isEdit ? 'Обновлено' : ''
          this.modal.active = true
        })
        .catch((err) => {
          this.modal = { ...defaultModal }
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    resetPassword() {
      this.modal = { ...defaultModal }
      this.axios({
        url: `/v1/users/${this.$route.params.id}/reset-password`,
        method: 'post',
      })
        .then((resp) => {
          this.modal.messagePassword = resp.data.password
          this.modal.active = true
        })
        .catch((err) => {
          this.$log.error(err)
          this.modal = { ...defaultModal }
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    siteSelected(e) {
      this.user.region = e.key
    },
    pickFile() {
      this.$refs.imageInput.click()
    },
    onFilePicked(e) {
      const image = {}
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        image.name = this.imageName
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          image.url = fr.result
          image.file = files[0]
          this.avatar = image
        })
      } else {
        this.imageName = ''
      }
    },
  },
}
</script>
